// src/components/LanguageSelector.tsx
import { Language } from "@constants/language";
import React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import { Theme } from "../enum/Theme";
import SpaceH from "@comps/SpaceH";

interface Props {
  value: Language;
  onChange: (lang: Language) => void;
}

const languages: { label: string; value: Language }[] = [
  { label: "Português", value: Language.PT },
  { label: "Inglês", value: Language.EN },
  { label: "Espanhol", value: Language.ES },
];

export const LanguageSelector: React.FC<Props> = ({ value, onChange }) => (
  <View>
    <Text style={styles.section}>Selecione o idioma:</Text>
    <SpaceH />
    <View style={styles.container}>
    {languages.map((lang) => (
      <TouchableOpacity
        key={lang.value}
        style={[styles.button, value === lang.value && styles.selected]}
        onPress={() => onChange(lang.value)}
      >
        <Text style={value === lang.value ? styles.selectedText : styles.text}>{lang.label}</Text>
      </TouchableOpacity>
    ))}
  </View>
  </View>
);

const styles = StyleSheet.create({
   section: { marginTop: 15, fontWeight: "bold" },
  container: { flexDirection: "row", marginBottom: 15 },
  button: {  padding: 10, borderRadius: 5, marginHorizontal: 3, backgroundColor: "#eee" },
  selected: { backgroundColor: Theme.foreground },
  text: { textAlign: "center" },
  selectedText: { color: "#fff", fontWeight: "600", textAlign: "center" },
});
